import { render, staticRenderFns } from "./LogoutPage.vue?vue&type=template&id=5e1f9946"
import script from "./LogoutPage.vue?vue&type=script&lang=js"
export * from "./LogoutPage.vue?vue&type=script&lang=js"
import style0 from "./LogoutPage.vue?vue&type=style&index=0&id=5e1f9946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports